module.exports = __webpack_public_path__ + "img/hero_mv_sp.3afeb366.jpg";